import * as React from 'react';
import icon from '../../assets/img/flags/alabama.svg';

export const Alabama = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
